export const genderToColor = {
    "You": "red",
    "Male": "#2761F5",
    "Female": "#d45fdf",
    "Nonbinary / Gender diverse": "#fff200ff",
    "Prefer not to answer": "#7e828cff"
}